module.exports = __webpack_public_path__ + "img/744.f76e2ec2.jpg";